import './login.css';
import { Link } from 'react-router-dom';
import imgLoginBackLeft from "../../../assets/imgs/login/login-back-left.jpg";
import imgLoginBackLeft2 from "../../../assets/imgs/login/login-back.png";
import groupAmc from "../../../assets/imgs/login/logo_AMC.svg";
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';

function Login() {

    const { loginWithRedirect } = useAuth0()

    useState(() => {
        localStorage.clear();
    })

    return (
        <div className="loginImgBg">
            <div className="loginContainer">
                <div className='loginBackImage'>
                    <img className='imgLoginBackLeft' src={imgLoginBackLeft2} alt="" />
                    <img className='groupAmc' src={groupAmc} alt='' />
                </div>

                <div className='loginFormContainer'>
                    <img src={groupAmc} alt='' className="loginSide"/>

                    <button onClick={() => loginWithRedirect()} className="loginValidClass">
                        Iniciar Sesion
                    </button>
                </div>
            </div>
            <div className='contCopyright'>
                <span>©Copyright {new Date().getFullYear()} | Derechos Reservados, Aeroméxico Cargo.</span>
            </div>
        </div>
    )
}

export default Login;